import Lottie from "lottie-react";
import lottieJson from "./pulse-grey.json";

interface LottieAnimationProps {
  style?: React.CSSProperties;
}

const LottieAnimation = ({ style }: LottieAnimationProps) => {
  return (
    <Lottie
      animationData={lottieJson}
      loop={true}
      style={{
        ...style,
      }}
    />
  );
};

export default LottieAnimation;
